interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "KMF";
};

const KMF: Currency = Object.freeze({
  "displayName": "Comoro Franc",
  "numericCode": 174,
  "defaultFractionDigits": 0,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "KMF",
  "symbol": "Fr"
});

export { KMF };
